const NeonActions = {
    REQUIRE_MFA: 'REQUIRE_MFA',
    REQUIRE_PW_RESET: 'REQUIRE_PW_RESET'
};

export default NeonActions;
